/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ITimelineData } from './timeline.data';
import { ITimelineProps } from './timeline.props.autogenerated';

export interface ITimelineViewProps extends ITimelineProps<ITimelineData> {}

/**
 *
 * Timeline component
 * @extends {React.PureComponent<ITimelineProps<ITimelineData>>}
 */
class Timeline extends React.PureComponent<ITimelineProps<ITimelineData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default Timeline;
